import { BaseService } from './baseService';

class SmsMessagesService extends BaseService<
	SmsMessage,
	'smsMessageID',
	'smsMessages'
> {
	constructor() {
		super('smsMessageID', 'smsMessage', 'smsMessages');
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new SmsMessagesService();
